import { Row, T8y } from 'ui';

import benefitIcon2 from 'assets/images/icons/benefits/wilko-benefit1.png';
import benefitIcon1 from 'assets/images/icons/benefits/wilko-benefit2.png';
import benefitIcon3 from 'assets/images/icons/benefits/wilko-benefit4.png';

import style from './benefits.module.scss';

const benefits = [
  { icon: benefitIcon1, text: 'Easy online checkout' },
  { icon: benefitIcon2, text: 'Trusted by users and companies' },
  { icon: benefitIcon3, text: 'Fast delivery service' },
];

export const Benefits = () => {
  return (
    <div className={style.benefits}>
      <T8y bold mb>
        Benefits of hiring with us
      </T8y>
      {benefits.map((el, i) => (
        <Row key={i} align="center" noWrap>
          <img
            src={el.icon}
            alt={'benefit' + i + 1}
            className={style.benefitIcon}
          />
          <T8y>{el.text}</T8y>
        </Row>
      ))}
    </div>
  );
};
